import config from "../../../configs/sys32config";
import { GetRequest } from "../../../utils/API";
import { LOGIN, SET_ACCESS_IP } from "../../../utils/Endpoints";
import _ from "lodash"

const axios = require("axios");

const TYPES = {
  REQUEST_LOGIN: "REQUEST_LOGIN",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILED: "LOGIN_FAILED",
};

const getLogin = ({ username, password }) => {
  return  (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_LOGIN,
      payload: {},
    });
    try {
      var bodyFormData = new FormData();
      bodyFormData.append("username", username);
      bodyFormData.append("password", password);
      bodyFormData.append("grant_type", "password");
      axios({
        method: "post",
        url: LOGIN,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": "true",
          "Accept": "application/json",
          "Content-Type": "multipart/form-data",
          "Authorization": `${config.basic_header}`,
        },
        data: bodyFormData,
      })
        .then((result) => {
          
          setAccessIp(result)
          dispatch({
            type: TYPES.LOGIN_SUCCESS,
            payload: { result },
          });
        })
        .catch((error) => {
          // console.log(">axios error:", error);
          dispatch({
            type: TYPES.LOGIN_FAILED,
            payload: { error },
          });
        });
      // return response;
    } catch (error) {
      // console.log(">axios error:", error);
      dispatch({
        type: TYPES.LOGIN_FAILED,
        payload: { error },
      });
    }
  };
};

const setAccessIp = (data) => {
  let token = _.get(data, 'data.access_token', null)
  axios({url: 'https://www.cloudflare.com/cdn-cgi/trace', method: 'get', headers: {
      "Accept": "application/json",
      'Content-Type': 'application/json;charset=UTF-8',
    }}).then(fetch => {
      const data = fetch.data.split("\n")
      const ipV4 = data[2].replace("ip=", '')
      const uag = data[5].replace("uag=", '')
      const loc = data[8].replace("loc=", '')
      axios({url: SET_ACCESS_IP, method: 'get', headers: {
        'X-Forwarded-For' : ipV4,
        'X-Uag-For': `${uag}, ${loc}`,
        'Authorization' : `Bearer ${token}`
      }});
    });
}

// const getLogin1 = ({ username, password }) => {
//   return (dispatch) => {
//     dispatch({
//       type: TYPES.REQUEST_LOGIN,
//       payload: {},
//     });
//     try {
//       var bodyFormData = new FormData();
//       bodyFormData.append("username", username);
//       bodyFormData.append("password", password);
//       bodyFormData.append("grant_type", "password");
//       axios({
//         method: "post",
//         url: LOGIN,
//         headers: {
//           "Access-Control-Allow-Origin": "*",
//           "Access-Control-Allow-Credentials": "true",
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//           "Grant-Type": "password",
//           Authorization: `${config.basic_header}`,
//         },
//         data: bodyFormData,
//       })
//         .then((result) => {
//           console.log(">login result", result);
//           dispatch({
//             type: TYPES.LOGIN_SUCCESS,
//             payload: { result },
//           });
//         })
//         .catch((error) => {
//           console.log(">axios error:", error);
//           dispatch({
//             type: TYPES.LOGIN_FAILED,
//             payload: { error },
//           });
//         });
//       // return response;
//     } catch (error) {
//       console.log(">axios error:", error);
//       dispatch({
//         type: TYPES.LOGIN_FAILED,
//         payload: { error },
//       });
//     }
//   };
// };

export default {
  getLogin,
  //getLogin1,
  TYPES,
};
